<template>
  <div>
    <span>
      {{ `${money.currency_code} ${money.amount}` }}
    </span>
  </div>
</template>

<script>
export default {
  name: "MoneyTotal",
  props: ['money']
}
</script>

<style scoped>

</style>